import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {api} from '../services/config'
export default function BankPage() {
  const [state, setState] = useState(100);
  const navigate = useNavigate()
  const queryString = new URLSearchParams(window.location.search)

  const au = queryString.get('au')
  const gateway = queryString.get('gateway')
  
  useEffect(() => {
    
    const fetchStatus=async () => {
      try {
        const response = await api.get(`payment/detail?au=${au}&&gateway=${gateway}`,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('login')}`
            }   
        })
        setState(response.data.data.status)
      } catch (error) {
        console.log(error)
        navigate('/')
      }
    }

    fetchStatus()
  }, [au])
  
  
  return (
    <div className="w-full">
      {state === 100 ? (
        <div className="w-[80%] lg:w-[40%] bg-gray-300 h-auto py-6 px-2 mx-auto mt-20 rounded-lg">
          <div className="flex flex-col items-center justify-between gap-3">
            <div>
              <img
                src="/images/happy.jpg"
                className="w-56 rounded-full"
                alt=""
              />
            </div>
            <div className="flex flex-col items-center gap-3">
              <p className="text-6xl text-green-600">بله ! </p>
              <p className="text-green-600"> پرداخت با موفقیت انجام شد .</p>
            </div>
            <div className="text-green-600">
              هم اکنون حساب درگاه اینترنتی شما شارژ گردید
            </div>
          </div>
        </div>
      ) : (
        <div className="w-[80%] lg:w-[40%] bg-gray-300 h-auto py-6 px-2 mx-auto mt-20 rounded-lg">
          <div className="flex flex-col items-center justify-between gap-3">
            <div>
              <img src="/images/low.jpg" className="w-56 rounded-full" alt="" />
            </div>
            <div className="flex flex-col items-center gap-3">
              <p className="text-4xl text-red-600">خطا در پرداخت ! </p>
              <p className="text-red-600"> پرداخت با موفقیت انجام نشد .</p>
            </div>
            <div className="text-red-600">
              پس از بررسی در صورت نیاز ، به شما ایمیل خواهیم داد .
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
